exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-4ec95e6d]:nth-child(2n){background-color:#f4f5f7}", ""]);

// exports
